import React from 'react';

import QuestionHOC from './QuestionHOC';

export default function Medications({ index, item }) {
  const displayQuestion = () => {
    if (item.hasOwnProperty('onlyAnswer') && item.onlyAnswer === true) {
      return <div className="col">Ibuprofen, Lipitor</div>
    } else {
      return <>
        <div className="col-8">Medications</div>
        <div className="col-4">Ibuprofen, Lipitor</div>
      </>
    }
  }

  return <QuestionHOC item={item} index={index}>
    <div className="row">
      {displayQuestion()}
    </div>
  </QuestionHOC>
}